import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage
} from '../utils/productHelpers';

const SimpleAmped15AhLifePO4 = () => {
  console.log('🎯 SimpleAmped15AhLifePO4 component loading');
  
  // Find the main battery product to get the variant
  const mainProduct = findProductById("amped-15ah-lifepo4");
  
  if (!mainProduct || !mainProduct.variants || !mainProduct.variants.withoutCharger) {
    console.error('Product or variant not found:', "amped-15ah-lifepo4");
    return <div>Product not found</div>;
  }
  
  // Use the variant that has the correct csvLookupId
  const product = mainProduct.variants.withoutCharger;
  
  return (
    <SimpleProductPage 
      specificProductId={product.id}
      productName={product.name}
      productImage={getProductImage(mainProduct)} // Use main product image
      csvLookupId={product.csvLookupId} // Use variant's csvLookupId
    />
  );
};

export default SimpleAmped15AhLifePO4; 